export const SHOW_STATUS_BANNER = true;
export const STATUS_BANNER_MESSAGE =
  "Development will be slowed down for a period. We appreciate your patience. Share your thoughts on our feedback page.";
